module.exports = __webpack_public_path__ + "media/images/pic/lesson-f0bec732a883b7adec15becb150ece4f.jpeg";